'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // Lib


// Components


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _FullScreenModal = require('./FullScreenModal');

var _FullScreenModal2 = _interopRequireDefault(_FullScreenModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RouteModalRoot = function RouteModalRoot(props) {
    return _react2.default.createElement(
        _FullScreenModal2.default,
        _extends({ overlay: true }, props),
        props.children
    );
};

RouteModalRoot.propTypes = {
    children: _propTypes2.default.node
};

exports.default = RouteModalRoot;


//////////////////
// WEBPACK FOOTER
// ./src/client/components/modal/RouteModalRoot.js
// module id = 1919
// module chunks = 0